module.exports = __webpack_public_path__ + "static/img/data-empty.85ceb63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/data-empty.png
// module id = mw7i
// module chunks = 1